import { STRINGS } from "../strings";
import { translate } from "../translate";
import { FormControl } from "./FormControl";

export interface ValidatorReturnType {
  [key: string]: boolean;
}

export class Validators {
  static required(formControl: FormControl): ValidatorReturnType {
    return {
      required: formControl.isEmpty(),
    };
  }

  static email(formControl: FormControl): ValidatorReturnType {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const value = formControl.value;

    return {
      email: typeof value === "string" && value.length > 0 && !regex.test(value),
    };
  }

  static toTranslate(error: string | null): string | null {
    switch (error) {
      case "required":
        return translate(STRINGS.REQUIRED);
      case "email":
        return translate(STRINGS.INVALID_EMAIL);
      default:
        return error;
    }
  }
}
